<footer class="footer site-footer">
    <div class="footer-wrap pbmit-footer-big-area">
        <div class="container">
            <div class="row align-items-center">
                <div class="pbmit-footer-boxes pbmit-footer-boxes-1 col-md-4">
                    <div class="pbmit-footer-contact-info">
                        <div class="pbmit-footer-contact-info-inner d-flex align-items-center">
                            <i class="pbmit-lyfpro-icon pbmit-lyfpro-icon-pin"></i>
                            <div class="pbmit-footer-contact-info-wrap">
                                <span class="pbmit-label pbmit-label-1">Office Address</span> Hi-Tech City, Hyderabad, Telangana - 500 081
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pbmit-footer-boxes pbmit-footer-boxes-2 col-md-4">
                    <div class="pbmit-footer-contact-info">
                        <div class="pbmit-footer-contact-info-inner d-flex align-items-center">
                            <i class="pbmit-lyfpro-icon pbmit-lyfpro-icon-email-1"></i>
                            <div class="pbmit-footer-contact-info-wrap">
                                <span class="pbmit-label pbmit-label-2">24 X 7 online support</span> Support@Sharaniponguru.me
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pbmit-footer-boxes pbmit-footer-boxes-3 col-md-4">
                    <div class="pbmit-footer-contact-info">
                        <div class="pbmit-footer-contact-info-inner d-flex">
                            <i class="pbmit-lyfpro-icon pbmit-lyfpro-icon-call"></i>
                            <div class="pbmit-footer-contact-info-wrap">
                                <span class="pbmit-label pbmit-label-3">{{contactPageObj.title}}</span> <span [innerHTML]="contactPageObj.description"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class = "social-media-icons">
                <a href = "https://www.facebook.com/sharaninarayanaofficial/" target = "_blank">
                    <i class = "fab fa-facebook" style="color: #1877f2"></i>
                </a>
                <a href = "https://www.instagram.com/sharaninarayanaofficial/" target = "_blank">
                    <i class = "fab fa-instagram" style="color: #e4405f"></i>
                </a>
                <a href = "https://www.linkedin.com/in/sharaninarayanaofficial/" target = "_blank">
                    <i class = "fab fa-linkedin" style="color: #0077b5"></i>
                </a>
                <a href = "https://www.youtube.com/@TheSharaniPonguruWay" target = "_blank">
                    <i class = "fab fa-youtube" style="color: #ff0000"></i>
                </a>
                <a href = "https://x.com/sharaniponguru" target = "_blank">
                    <i class = "fab fa-twitter" style="color: #1da1f2"></i>
                </a>
            </div>
        </div>
    </div>
    
    <div class="pbmit-footer-bottom">
        <div class="container">
            <div class="pbmit-footer-text-inner">
                <div class="row">
                    <div class="col-12 text-center">
                        <ul class="policy-links pbmit-footer-menu ps-0 justify-content-center flex-wrap">
                            <li class="menu-item d-inline-block mb-2 me-3"><a href="/privacy-policy">Privacy Policy</a></li>
                            <li class="menu-item d-inline-block mb-2 me-3"><a href="/refund-policy">Refund Policy</a></li>
                            <li class="menu-item d-inline-block mb-2 me-3"><a href="/cancellation-policy">Cancellation Policy</a></li>
                            <li class="menu-item d-inline-block mb-2 me-3"><a href="/shipping-delivery-policy">Shipping & Delivery Policy</a></li>
                            <li class="menu-item d-inline-block mb-2 me-3"><a href="/disclosure">Disclosure</a></li>
                            <li class="menu-item d-inline-block mb-2 me-3"><a href="/disclaimer">Disclaimer</a></li>
                            <li class="menu-item d-inline-block mb-2 me-3"><a href="/terms-conditions">Terms & Conditions</a></li>
                        </ul>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="footer-copyright-text-area col-12 text-center">
                        <div class="pbmit-footer-copyright-text-area">Copyright ©2025 Sharaniponguru.me. All Rights Reserved.</div>
                        <div class="pbmit-footer-copyright-text-area">Powered by <a class="powered-by-ailearns" href="https://www.ailens.ai" target="_blank"><img class="logo-img" src="assets/Logo/Ailens-logo.png" alt="AILENS.AI" style="width: 100px; height: 20px;"></a></div>  
                    </div>
                </div>
            </div>	
        </div>
    </div>	
</footer>
<app-chat-bot *ngIf="checkLogin()"></app-chat-bot>